export const STEP_SELECT_COPY_TO_PACKAGES = 'select_copy_to_packages';
export const STEP_SELECT_COPIED_PACKAGE_FIELDS = 'select_copied_package_fields';
export const STEP_CONFIRM_COPIED_PACKAGES = 'confirm_copied_packages';
export const RISKY_FIELDS_TO_BE_COPIED = ['fk_room_rate_id', 'fk_room_type_id', 'sort_order'];
